function initSwiper() {
  const sliderOptions = {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 2,
    navigation: {
      nextEl: '[data-swiper-button-next]',
      prevEl: '[data-swiper-button-prev]',
    },
    breakpoints: {
      280: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      374: {
        slidesPerView: "auto",
        spaceBetween: 0,
      }
    },
    on: {
      init() {
        const slides = this.el.querySelectorAll('[data-swatches-slide]');
        const currentBreakpoint = this.currentBreakpoint || Object.keys(this.params.breakpoints).pop();
        const slidesPerView = this.params.breakpoints[currentBreakpoint]?.slidesPerView || this.params.slidesPerView;
        let slidesToCompare;
      
        if (slidesPerView === 'auto') {
          slidesToCompare = 5;
        } else {
          slidesToCompare = slidesPerView;
        }
      
        if (slides.length > slidesToCompare) {
          this.el.classList.add("product-card__swatches--padding");
          this.el.parentElement.classList.add("product-card__swatches--style");
        } else {
          this.el.querySelectorAll("[data-swatches-slide]").forEach(element => {
            element.style.width = "max-content";
            element.style.margin = 0;
          });
        }
      }
    },
  };
  var new_slider = new window.FoxTheme.Carousel('[data-swatches-slider]', sliderOptions);
  new_slider.init();
}
initSwiper();